import { useQuery } from '@tanstack/react-query';
import HttpClient from '@/api/HttpClient';

const httpClient = new HttpClient();

export interface InventoryAuditorDashboardRange {
  dateFrom: string;
  dateTo: string;
  days: number;
}

export interface InventoryAuditorDashboardSummary {
  totalUnitsOnHand: number;
  skusWithStock: number;
  catalogItemCount: number;
  activeLocations: number;
  movementCountInRange: number;
  storeCountMovementCountInRange: number;
  adjustmentMovementCountInRange: number;
}

export interface InventoryAuditorDashboardMovementsByDayRow {
  date: string;
  siteVisitUnits: number;
  adjustmentUnits: number;
  otherUnits: number;
  total: number;
}

export interface InventoryAuditorDashboardStoreCountMovesByDayRow {
  date: string;
  count: number;
}

export interface InventoryAuditorDashboardInventoryByLocationRow {
  locationId: number;
  locationName: string;
  totalUnits: number;
}

export interface InventoryAuditorDashboardMovementsByReasonRow {
  reason: string;
  movementCount: number;
  totalQuantity: number;
}

export interface InventoryAuditorDashboardPayload {
  range: InventoryAuditorDashboardRange;
  summary: InventoryAuditorDashboardSummary;
  movementsByDay: InventoryAuditorDashboardMovementsByDayRow[];
  storeCountMovesByDay: InventoryAuditorDashboardStoreCountMovesByDayRow[];
  inventoryByLocation: InventoryAuditorDashboardInventoryByLocationRow[];
  movementsByReason: InventoryAuditorDashboardMovementsByReasonRow[];
}

export async function fetchInventoryAuditorDashboard(
  days = 30,
): Promise<InventoryAuditorDashboardPayload> {
  const response = await httpClient.post('api/inventory-auditor/dashboard', { days });
  return response.data as InventoryAuditorDashboardPayload;
}

export function useInventoryAuditorDashboard(days = 30) {
  return useQuery({
    queryKey: ['inventory-auditor-dashboard', days],
    queryFn: () => fetchInventoryAuditorDashboard(days),
    staleTime: 60_000,
  });
}
